/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/

// CardCarousel Component
import React, { PureComponent } from "react";
import Slider from "react-slick";
import { find } from "lodash";
import { Base64 } from 'js-base64';
import ContentLoader from "react-content-loader";
import Icon from "../Icons";
import Heading from "../../components/Heading";
import HeartUnFilled from '../../assets/img/heartunfilled.png';
import HeartFilled from '../../assets/img/heartFilledRed.png';

import { deepEqual, formatDateDDMMMYYYY } from "../../pages/helper";
import {
  interaction,
  getError
} from "../../service";
import uiConfig from "../../uiConfig";
import NewCard from "../New_Card";
import {arabicContent} from "../../constants/index";
import config from "../../service/config";

const lang = localStorage.getItem("language");

function SampleNextArrow(props) {
  const { className, style, onClick} = props;
  return (
    <div className={className} onClick={onClick}>
      <div className={`circleADB`}>
        {onClick === null ? 
          <Icon fill="#ccc" width={10} height={10} name="arrowRight" /> :
          <Icon fill="#000" width={10} height={10} name="arrowRight" />
        }
      </div>          
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      <div className={`circleADB`}>
        {onClick === null ? 
          <Icon fill="#ccc" width={10} height={10} name="arrowLeft" /> :
          <Icon fill="#000" width={10} height={10} name="arrowLeft" />
        }
      </div>       
    </div>
  );
}

export default class SimilarMerchants extends PureComponent {
  state = {
    isLoad: true,
    currentPageItems: [],
    itemList:this.props.itemList,
    currentPage:1
  };

  componentDidMount() {
    this.updateRenderLoad();
    // this.currentPageList();
  }

  loadImage = (weburl,imageurl) => {
    if("https://logo.clearbit.com/"+weburl+"?size=800"){
      return "https://logo.clearbit.com/"+weburl+"?size=800";
    } else {
      return imageurl;
    }
  }

  onErrorImg = () => {}

  updateRenderLoad = () => {
  //    setTimeout(() => {
      //Start the timer
      this.setState({ isLoad: false }); //After 5 second, set render to true
  //    }, 5000);
  };

  userInteraction = (e,itemId,type,imgId) => {
    e.stopPropagation();
    e.preventDefault();
    var imgSrc = document.getElementById(imgId).getAttribute("data");
    if(imgSrc == "UNDO_WISHLIST"){
      if (localStorage.getItem("USERID")===null) {
        this.props._openLogin();
        localStorage.setItem("interactionType","WISHLIST");
        localStorage.setItem("interactionId",itemId);
      }
      if (localStorage.getItem("USERID")) {
        document.getElementById(imgId).setAttribute("data", "WISHLIST");
        document.getElementById(imgId).src = HeartFilled;
        interaction("WISHLIST", "MERCHANT", itemId)
        .then((res) => {
        })
        .catch((err) => {
          if (err && err.data && err.data.status === 404) {
          } else {
        //    console.log(getError(err));
          }
        });
      }
    } else {
      document.getElementById(imgId).setAttribute("data","UNDO_WISHLIST");
      document.getElementById(imgId).src = HeartUnFilled;
      interaction("UNDO_WISHLIST", "MERCHANT",itemId)
      .then((res) => {
      })
      .catch((err) => {
        if (err && err.data&&err.data.status === 404) {
        } else {
       //   console.log(getError(err));
        }
      });
    }
  }

//   currentPageList = () => {
//     const { itemList } = this.props;
//     let currentPageItems = [...this.state.currentPageItems];
//     if (itemList && itemList.length > 0 && currentPageItems.length === 0) {
//       currentPageItems = itemList.map((items, idx) => {
//         return {
//           idx,
//           id: items.id,
//           currentPage: 1,
//           totalItems: items
//         };
//       });

//       this.setState({ currentPageItems });
//     }
  //   };
  
  debounce=(func, delay)=> {
    let timerId;
  
    return function (...args) {
      clearTimeout(timerId);
  
      timerId = setTimeout(() => {
        func(...args);
      }, delay);
    };
  }

  /* OnClick Function */
  next = () => {
    let currentPage = this.state.currentPage;
    const width=window.innerWidth;
    const listPerPage = width>=480?4:1;
    let totalPage = Math.ceil(this.props.itemList.length/ listPerPage);
    this.slider.slickNext();
   
    if (currentPage < totalPage ) {
      currentPage += 1;
      this.setState({ currentPage });
    }
  };

  previous = () => {
    let currentPage = this.state.currentPage;
    const width=window.innerWidth;
    const listPerPage = width>=480?4:1;
    let totalPage = Math.ceil(this.props.itemList.length/ listPerPage);
    this.slider.slickPrev();

    if (currentPage > 1) {
     currentPage -= 1;
      this.setState({ currentPage });
    }
  };

  // Arabic RTL
  nextRTL = () => {
    let currentPage = this.state.currentPage;
    const width=window.innerWidth;
    const listPerPage = width>=480?4:1;
    let totalPage = Math.ceil(this.props.itemList.length/ listPerPage);
    this.slider.slickPrev();
   
    if (currentPage < totalPage ) {
      currentPage += 1;
      this.setState({ currentPage });
    }
  };

  previousRTL = () => {
    let currentPage = this.state.currentPage;
    const width=window.innerWidth;
    const listPerPage = width>=480?4:1;
    let totalPage = Math.ceil(this.props.itemList.length/ listPerPage);
    this.slider.slickNext();

    if (currentPage > 1) {
      currentPage -= 1;
      this.setState({ currentPage });
    }
  };


  /* Other Render Function */
  renderHeader( itemList,listPerPage) {
    const { currentPage } = this.state;
    const width=window.innerWidth;
    const prevThrottle =  this.debounce(this.previous, 500);
    const prevRTLthrottle =  this.debounce(this.previousRTL, 500);
    const  nextRTLthrottle =  this.debounce(this.nextRTL, 500);
    const nextThrottle = this.debounce(this.next, 500);
    //const listPerPage = width>=480?4:1;
    let totalPage = 0;
    totalPage = Math.ceil(itemList.length/ listPerPage)
     
    return (
      <div className="flex similar-merchants-title">
         {width > 768 && 
        <div className="title-div flex-start">
        <Heading title={this.props.itemType ?<span>Similar offers you may like, based on your recent exploration</span> : <span className="title-div flex-start">Offers that help to unlock the vouchers,<span style={{fontWeight:400}}>&nbsp;based on your recent exploration</span></span>} />
        </div>
  }
      {width < 768 && 

<div className="title-div flex-start">

  <Heading title={this.props.itemType ?<span>Similar offers you may like, based on your recent exploration</span> : <span className="title-div flex-start">Offers that help to unlock the vouchers, based on your recent exploration</span>} />

</div>

}
        {
          width > 768 && config.clientName!=="ADIB" && itemList.length > listPerPage &&
          <div className={`flex-end ${lang === "AR" ? "margin-left" : "margin-right"}`}>
            <div className={`_ai-self ${lang === "AR" ? " ml-15" : " mr-15"}`}>
              <Heading
                title={`${currentPage}/${totalPage}`}
                varient="list"
              />
            </div>
            {lang === "EN" ?
            <>
              <div
                className={`circle mr-8 ${
                  currentPage === 1 ? "disable" : ""
                }`}
                onClick={() => prevThrottle()}
              >
                {
                  currentPage === 1 ? 
                  <Icon fill="#ccc" width={12} height={10} name="arrowLeft" />
                  :
                  <Icon fill={uiConfig.config.whitelabel.components.card.arrowColor} width={12} height={10} name="arrowLeft" />
                }
              </div>
              <div
                className={`circle ${
                  currentPage === totalPage
                    ? "disable"
                    : ""
                }`}
                onClick={() => nextThrottle()}
              >
                {
                  currentPage === totalPage ?
                  <Icon fill="#ccc" width={12} height={10} name="arrowRight" />
                  :
                  <Icon fill={uiConfig.config.whitelabel.components.card.arrowColor} width={12} height={10} name="arrowRight" />
                }
              </div>
            </> :
            <>
              <div
                className={`circle ml-8 ${
                  currentPage === 1 ? "disable" : ""
                }`}
                onClick={() => prevRTLthrottle()}
              >
                {
                  currentPage === 1 ? 
                  <Icon fill="#ccc" width={12} height={10} name="arrowRight" />
                  :
                  <Icon fill={uiConfig.config.whitelabel.components.card.arrowColor} width={12} height={10} name="arrowRight" />
                }
              </div>
              <div
                className={`circle ${
                  currentPage === totalPage
                    ? "disable"
                    : ""
                }`}
                onClick={() =>  nextRTLthrottle()}
              >
                {
                  currentPage === totalPage ?
                  <Icon fill="#ccc" width={12} height={10} name="arrowLeft" />
                  :
                  <Icon fill="#000" width={12} height={10} name="arrowLeft" />
                }
              </div>
            </> 
          }
          </div>
        }
      </div>
    );
  }

componentWillReceiveProps(nextProps){
  if(!deepEqual(nextProps.itemList,this.state.itemList)){
    this.setState({
      currentPageItems:[],
      itemList:nextProps.itemList
    },
    // ()=> this.currentPageList()
    )
  }
}

  /* Main Render Functions */
  render() {
    const { itemList } = this.state;
    const settings = {
      dots: false,
      infinite: false,
      arrow: false,
      slidesToShow: window.innerWidth > 1910 ? 5 : 4,
      slidesToScroll: window.innerWidth > 1910 ? 5 : 4,
      rtl:lang==="AR"?true:false,
      initialSlide: lang==="AR"?3.1:0,
      nextArrow: config.clientName==="ADIB"?<SampleNextArrow />:null,
      prevArrow: config.clientName==="ADIB"?<SamplePrevArrow />:null,
      responsive: [
        {
          breakpoint: 1500,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            dots: false
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1.1,
            slidesToScroll: 1,
            infinite: false,
            dots: false,
            nextArrow: null,
            prevArrow: null
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1.5,
            slidesToScroll: 1,
            nextArrow: null,
            prevArrow: null
          }
        }
      ]
    };

    return (
        <span className="main_container_Similar_Merchant">
            <div className={`card_carousel similar-merchants ${lang ==="AR" ? "carousel_arabic" : ""}`}>
              {this.renderHeader(itemList,settings.slidesToShow)}
              <Slider
                {...settings}
                ref={(c) => {
                  this.slider = c;
                }}
              >
              {itemList.map((eachItem,idx) =>
                  <div className="slide">
                <NewCard lastCard={itemList.length-1 === idx} _openLogin={this.props._openLogin} item={eachItem} wishlisted={eachItem.properties.wishlisted} itemId={eachItem.id} history={this.props.history} userInteraction={this.userInteraction} listName={"similar"} checkColor={this.props.checkColor}/>
                </div>        
                )}
              </Slider>  
            </div>
        </span>
    );
  }
}